module.exports = __webpack_public_path__ + "img/4.83d90929.png";